import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Hüllt Seiteninhalt in eine dezente Eingangsanimation (`.sec-page-enter`).
 * CSS-basiert (kein Animations-Framework); respektiert prefers-reduced-motion.
 */
export const PageTransition = forwardRef(function PageTransition({ className, children, ...rest }, ref) {
    return (_jsx("div", { ref: ref, className: cn('sec-page-enter', className), ...rest, children: children }));
});
